import React from "react"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `StaticQuery`: https://gatsby.dev/staticquery
 */

 const months = [
     'gennaio',
     'febbraio',
     'marzo',
     'aprile',
     'maggio',
     'giugno',
     'luglio',
     'agosto',
     'settembre',
     'ottobre',
     'novembre',
     'dicembre'
 ]

const DateFormatter = ({date}) => {
    var dateObj = new Date(date);
    return <>{dateObj.getDate()} {months[dateObj.getMonth()]} {dateObj.getFullYear()}</>;   
}
export default DateFormatter;